import Vue from 'vue'
import VueRouter from 'vue-router'
import { getRequest } from '../api/http'
import cookie from 'js-cookie'
Vue.use(VueRouter)

const routes = [
  {
    path: '/login',
    name: 'login',
    component: () => import('../views/login.vue')
  },
  {
    name: "找回密码",
    path: '/forgetPassword',
    component: () => import('../views/forgetPassword.vue')
  },
  {
    path: '/',
    component: () => import('../views/submenu/common.vue'),
    children: [
      {
        name: "职位管理",
        path: '',
        component: () => import('../views/positionManagement/positionManagement.vue')
      },
      {
        name: "招募人员岗位管理",
        path: '/positionRecruitCenter',
        component: () => import('../views/positionRecruitCenter/positionRecruitCenter.vue')
      },
      {
        name: "推荐/搜索",
        path: '/recommend',
        component: () => import('../views/recommend/recommend.vue')
      },
      {
        name: "沟通",
        path: '/communicate',
        component: () => import('../views/communicate/communicate.vue')
      },
      {
        name: "招聘管理",
        path: '/recruiting',
        component: () => import('../views/recruiting/recruiting.vue')
      },
      {
        name: "项目外包",
        path: '/projectOutsourcing',
        component: () => import('../views/projectOutsourcing/projectOutsourcing.vue')
      },
      {
        name: "招聘数据",
        path: '/recruitmentData',
        component: () => import('../views/recruitmentData/recruitmentData.vue')
      },
      {
        name: "企业加油站",
        path: '/gasStation',
        component: () => import('../views/gasStation/gasStation.vue')
      },
      {
        name: "个人中心",
        path: '/personalCenter',
        component: () => import('../views/personalCenter/personalCenter.vue')
      },
      {
        name: "地址管理",
        path: '/address',
        component: () => import('../views/address.vue')
      },
    ]
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})
function beforelink() {
  if (document.getElementsByClassName('el-main')[0]) {
    document.getElementsByClassName('el-main')[0].scrollTop = 0
  }
  document.body.scrollTop = 0
  document.documentElement.scrollTop = 0
  window.pageYOffset = 0
}
router.beforeEach((to, from, next) => {
  if (to.path == '/login' || to.path == '/forgetPassword') {
    // beforelink()
    if (cookie.get("companyUserId") && cookie.get("companyUserId") != 'undefined') {
      return next('/')
    }else{
      return next()
    }
  } else {
    if (cookie.get("companyUserId") && cookie.get("companyUserId") != 'undefined') {
      return next()
    } else {
      return next('/login')
    }
  }
})
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
export default router
